import { render, staticRenderFns } from "./GroupDisk.vue?vue&type=template&id=1ff4b4b6&scoped=true"
import script from "./GroupDisk.vue?vue&type=script&lang=js"
export * from "./GroupDisk.vue?vue&type=script&lang=js"
import style0 from "./GroupDisk.vue?vue&type=style&index=0&id=1ff4b4b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff4b4b6",
  null
  
)

export default component.exports